import { Component, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import * as actions from "../../store/actions/index";
import * as selectors from "../../store/reducers/index";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "ca-customer-import",
  templateUrl: "./import-customers.component.html",
  styleUrls: ["import-customers.component.scss"]
})
export class ImportCustomersComponent {
  loading: Observable<boolean>;
  preview = [
    {
      property: "firstName",
      header: "First Name"
    },
    {
      property: "lastName",
      header: "Last Name"
    },
    {
      property: "dateOfBirth",
      header: "Date of Birth"
    },
    {
      property: "address1",
      header: "Address 1"
    },
    {
      property: "address2",
      header: "Address 2"
    },
    {
      property: "town",
      header: "Town"
    },
    {
      property: "state",
      header: "State"
    },
    {
      property: "postcode",
      header: "Postcode"
    },
    {
      property: "country",
      header: "Country"
    }
  ];
  loading$: Observable<boolean>;
  results$: Observable<any[]>;
  error$: Observable<any>;
  progress$: Observable<number>;

  form = new FormGroup({});
  file: File;

  @ViewChild("fileInput") fileInput;

  constructor(public store: Store<any>) {
    this.store.dispatch(actions.BulkReset);
    this.loading$ = this.store.select(selectors.bulk.getLoading);
    this.results$ = this.store.select(selectors.bulk.getResults);
    this.error$ = this.store.select(selectors.bulk.getResults);
    this.progress$ = this.store.select(selectors.bulk.getProgress);
  }

  importEvent(payload: any) {
    if (this.form.valid) {
      let payload = this.form.value.rows;
      this.store.dispatch(actions.Customers.RequestBulkAddCustomers(payload));
    }
  }
  changed() {
    this.file = this.fileInput.nativeElement.files[0];
    this.fileInput.nativeElement.value = ""; // Clear so the same file can be chosen agian;
  }
}
